// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_collapsed__1EIN6 {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  padding: 8px;
  margin-top: 16px;
  margin-left: 12px;
  transition: transform 0.2s ease;
}
.styles_collapsed__1EIN6 img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.styles_collapsed__1EIN6:hover {
  transform: translateY(-2px);
}

.styles_chat__cL6TF {
  width: 340px;
  height: 520px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 16px;
  margin-left: 12px;
  z-index: 1000;
}
.styles_chat__cL6TF.styles_floating__\\+8170 {
  height: 360px;
  margin: 0;
  z-index: 9999;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.styles_header__HCJug {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #fafafa;
}

.styles_logoButton__-E4xR {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  transition: transform 0.2s ease;
}
.styles_logoButton__-E4xR img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.styles_logoButton__-E4xR:hover {
  transform: translateY(-2px);
}

.styles_title__ztkju {
  font-weight: 600;
  font-size: 15px;
  color: #1f2937;
  flex: 1 1;
}

.styles_headerActions__Mimzc {
  display: flex;
  align-items: center;
  gap: 8px;
}

.styles_clearButton__q9JFs {
  background: none;
  border: none;
  font-size: 12px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}
.styles_clearButton__q9JFs:hover {
  background: #f3f4f6;
  color: #374151;
}

.styles_dragHandle__f8\\+iR {
  cursor: grab;
  font-size: 16px;
  color: #9ca3af;
  padding: 4px;
  -webkit-user-select: none;
          user-select: none;
}
.styles_dragHandle__f8\\+iR:active {
  cursor: grabbing;
}
.styles_dragHandle__f8\\+iR:hover {
  color: #6b7280;
}

.styles_messages__Xa\\+jN {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #fafafa;
}
.styles_messages__Xa\\+jN::-webkit-scrollbar {
  width: 6px;
}
.styles_messages__Xa\\+jN::-webkit-scrollbar-track {
  background: transparent;
}
.styles_messages__Xa\\+jN::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.styles_welcome__T1hid {
  text-align: center;
  padding: 20px;
  color: #6b7280;
}
.styles_welcome__T1hid p {
  margin: 0 0 8px 0;
  font-size: 14px;
}
.styles_welcome__T1hid .styles_hint__vuddK {
  font-size: 13px;
  color: #9ca3af;
}

.styles_message__Guv4x {
  max-width: 85%;
  padding: 10px 14px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}
.styles_message__Guv4x.styles_user__uxMF9 {
  align-self: flex-end;
  background: #2563eb;
  color: white;
  border-bottom-right-radius: 4px;
  white-space: pre-wrap;
}
.styles_message__Guv4x.styles_assistant__sWyMk {
  align-self: flex-start;
  background: white;
  color: #1f2937;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.styles_message__Guv4x.styles_assistant__sWyMk p {
  margin: 0 0 8px 0;
}
.styles_message__Guv4x.styles_assistant__sWyMk p:last-child {
  margin-bottom: 0;
}
.styles_message__Guv4x.styles_assistant__sWyMk strong {
  font-weight: 600;
}
.styles_message__Guv4x.styles_assistant__sWyMk h3 {
  font-size: 14px;
  font-weight: 600;
  margin: 12px 0 6px 0;
}
.styles_message__Guv4x.styles_assistant__sWyMk h3:first-child {
  margin-top: 0;
}
.styles_message__Guv4x.styles_assistant__sWyMk ul, .styles_message__Guv4x.styles_assistant__sWyMk ol {
  margin: 4px 0;
  padding-left: 20px;
}
.styles_message__Guv4x.styles_assistant__sWyMk li {
  margin: 2px 0;
}
.styles_message__Guv4x.styles_loading__iH22D {
  display: flex;
  gap: 4px;
  padding: 14px 18px;
}

.styles_dot__DP3sJ {
  width: 8px;
  height: 8px;
  background: #9ca3af;
  border-radius: 50%;
  animation: styles_bounce__9Qp3- 1.4s infinite ease-in-out both;
}
.styles_dot__DP3sJ:nth-child(1) {
  animation-delay: -0.32s;
}
.styles_dot__DP3sJ:nth-child(2) {
  animation-delay: -0.16s;
}
.styles_dot__DP3sJ:nth-child(3) {
  animation-delay: 0s;
}

@keyframes styles_bounce__9Qp3- {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.styles_inputArea__L0q-C {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  background: white;
}
.styles_inputArea__L0q-C input {
  flex: 1 1;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  padding: 10px 16px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
}
.styles_inputArea__L0q-C input:focus {
  border-color: #2563eb;
}
.styles_inputArea__L0q-C input:disabled {
  background: #f9fafb;
}
.styles_inputArea__L0q-C input::placeholder {
  color: #9ca3af;
}

.styles_sendButton__YoA4O {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: #2563eb;
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease, transform 0.1s ease;
}
.styles_sendButton__YoA4O:hover:not(:disabled) {
  background: #1d4ed8;
}
.styles_sendButton__YoA4O:active:not(:disabled) {
  transform: scale(0.95);
}
.styles_sendButton__YoA4O:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.styles_mobileOverlay__V07cz {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.styles_mobileChatContainer__fJtnN {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 201;
}

.styles_mobileChatContent__EVyl2 {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  max-width: none !important;
  max-height: none !important;
}
.styles_mobileChatContent__EVyl2 .styles_header__HCJug {
  background: rgba(250, 250, 250, 0.95);
  backdrop-filter: blur(8px);
}
.styles_mobileChatContent__EVyl2 .styles_messages__Xa\\+jN {
  background: transparent;
  flex: 1 1;
  overflow-y: auto;
}
.styles_mobileChatContent__EVyl2 .styles_message__Guv4x.styles_user__uxMF9 {
  background: #2563eb;
}
.styles_mobileChatContent__EVyl2 .styles_message__Guv4x.styles_assistant__sWyMk {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
}
.styles_mobileChatContent__EVyl2 .styles_inputArea__L0q-C {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
}

.styles_closeButton__5t-dv {
  background: none;
  border: none;
  font-size: 20px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 8px;
  transition: color 0.2s;
}
.styles_closeButton__5t-dv:hover {
  color: #374151;
}`, "",{"version":3,"sources":["webpack://./src/components/chatbot/styles.module.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,0CAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAGE;EACE,2BAAA;AADJ;;AAKA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;AAFF;AAKE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,yCAAA;AAHJ;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,+BAAA;AAJF;AAME;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAJJ;AAOE;EACE,2BAAA;AALJ;;AASA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANF;;AASA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AANF;AAQE;EACE,mBAAA;EACA,cAAA;AANJ;;AAUA;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AAPF;AASE;EACE,gBAAA;AAPJ;AAUE;EACE,cAAA;AARJ;;AAYA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AATF;AAWE;EACE,UAAA;AATJ;AAYE;EACE,uBAAA;AAVJ;AAaE;EACE,mBAAA;EACA,kBAAA;AAXJ;;AAeA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AAZF;AAcE;EACE,iBAAA;EACA,eAAA;AAZJ;AAeE;EACE,eAAA;EACA,cAAA;AAbJ;;AAiBA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAdF;AAgBE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;EACA,qBAAA;AAdJ;AAiBE;EACE,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,yCAAA;AAfJ;AAkBI;EACE,iBAAA;AAhBN;AAkBM;EACE,gBAAA;AAhBR;AAoBI;EACE,gBAAA;AAlBN;AAqBI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAnBN;AAqBM;EACE,aAAA;AAnBR;AAuBI;EACE,aAAA;EACA,kBAAA;AArBN;AAwBI;EACE,aAAA;AAtBN;AA0BE;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAxBJ;;AA4BA;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,8DAAA;AAzBF;AA2BE;EACE,uBAAA;AAzBJ;AA4BE;EACE,uBAAA;AA1BJ;AA6BE;EACE,mBAAA;AA3BJ;;AA+BA;EACE;IACE,mBAAA;EA5BF;EA8BA;IACE,mBAAA;EA5BF;AACF;AA+BA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;AA7BF;AA+BE;EACE,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;AA7BJ;AA+BI;EACE,qBAAA;AA7BN;AAgCI;EACE,mBAAA;AA9BN;AAiCI;EACE,cAAA;AA/BN;;AAoCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;AAjCF;AAmCE;EACE,mBAAA;AAjCJ;AAoCE;EACE,sBAAA;AAlCJ;AAqCE;EACE,mBAAA;EACA,mBAAA;AAnCJ;;AAwCA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,qCAAA;EACA,2BAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AArCF;;AAwCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AArCF;;AAwCA;EACE,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kCAAA;EACA,0BAAA;EACA,2BAAA;AArCF;AAuCE;EACE,qCAAA;EACA,0BAAA;AArCJ;AAwCE;EACE,uBAAA;EACA,SAAA;EACA,gBAAA;AAtCJ;AAyCE;EACE,mBAAA;AAvCJ;AA0CE;EACE,qCAAA;EACA,0BAAA;AAxCJ;AA2CE;EACE,qCAAA;EACA,0BAAA;AAzCJ;;AA6CA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AA1CF;AA4CE;EACE,cAAA;AA1CJ","sourcesContent":["@import \"mixins\";\n.collapsed {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background: white;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  padding: 8px;\n  margin-top: 16px;\n  margin-left: 12px;\n  transition: transform 0.2s ease;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n\n  &:hover {\n    transform: translateY(-2px);\n  }\n}\n\n.chat {\n  width: 340px;\n  height: 520px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  margin-top: 16px;\n  margin-left: 12px;\n  z-index: 1000;\n\n  // Floating/detached state - 50% height only\n  &.floating {\n    height: 360px;\n    margin: 0;\n    z-index: 9999;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #fafafa;\n}\n\n.logoButton {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 0;\n  border-radius: 50%;\n  transition: transform 0.2s ease;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n\n  &:hover {\n    transform: translateY(-2px);\n  }\n}\n\n.title {\n  font-weight: 600;\n  font-size: 15px;\n  color: #1f2937;\n  flex: 1;\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.clearButton {\n  background: none;\n  border: none;\n  font-size: 12px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n\n  &:hover {\n    background: #f3f4f6;\n    color: #374151;\n  }\n}\n\n.dragHandle {\n  cursor: grab;\n  font-size: 16px;\n  color: #9ca3af;\n  padding: 4px;\n  user-select: none;\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  &:hover {\n    color: #6b7280;\n  }\n}\n\n.messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: #fafafa;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #d1d5db;\n    border-radius: 3px;\n  }\n}\n\n.welcome {\n  text-align: center;\n  padding: 20px;\n  color: #6b7280;\n\n  p {\n    margin: 0 0 8px 0;\n    font-size: 14px;\n  }\n\n  .hint {\n    font-size: 13px;\n    color: #9ca3af;\n  }\n}\n\n.message {\n  max-width: 85%;\n  padding: 10px 14px;\n  border-radius: 16px;\n  font-size: 14px;\n  line-height: 1.5;\n  word-wrap: break-word;\n\n  &.user {\n    align-self: flex-end;\n    background: #2563eb;\n    color: white;\n    border-bottom-right-radius: 4px;\n    white-space: pre-wrap;\n  }\n\n  &.assistant {\n    align-self: flex-start;\n    background: white;\n    color: #1f2937;\n    border-bottom-left-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n\n    // Markdown styling\n    p {\n      margin: 0 0 8px 0;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    strong {\n      font-weight: 600;\n    }\n\n    h3 {\n      font-size: 14px;\n      font-weight: 600;\n      margin: 12px 0 6px 0;\n\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n\n    ul, ol {\n      margin: 4px 0;\n      padding-left: 20px;\n    }\n\n    li {\n      margin: 2px 0;\n    }\n  }\n\n  &.loading {\n    display: flex;\n    gap: 4px;\n    padding: 14px 18px;\n  }\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  background: #9ca3af;\n  border-radius: 50%;\n  animation: bounce 1.4s infinite ease-in-out both;\n\n  &:nth-child(1) {\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    animation-delay: -0.16s;\n  }\n\n  &:nth-child(3) {\n    animation-delay: 0s;\n  }\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n\n.inputArea {\n  display: flex;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n  background: white;\n\n  input {\n    flex: 1;\n    border: 1px solid #e5e7eb;\n    border-radius: 20px;\n    padding: 10px 16px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s ease;\n\n    &:focus {\n      border-color: #2563eb;\n    }\n\n    &:disabled {\n      background: #f9fafb;\n    }\n\n    &::placeholder {\n      color: #9ca3af;\n    }\n  }\n}\n\n.sendButton {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  border: none;\n  background: #2563eb;\n  color: white;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s ease, transform 0.1s ease;\n\n  &:hover:not(:disabled) {\n    background: #1d4ed8;\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.95);\n  }\n\n  &:disabled {\n    background: #9ca3af;\n    cursor: not-allowed;\n  }\n}\n\n// Mobile fullscreen overlay\n.mobileOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 200;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.mobileChatContainer {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  z-index: 201;\n}\n\n.mobileChatContent {\n  width: 100% !important;\n  height: 100% !important;\n  margin: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  max-width: none !important;\n  max-height: none !important;\n\n  .header {\n    background: rgba(250, 250, 250, 0.95);\n    backdrop-filter: blur(8px);\n  }\n\n  .messages {\n    background: transparent;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  .message.user {\n    background: #2563eb;\n  }\n\n  .message.assistant {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(4px);\n  }\n\n  .inputArea {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(8px);\n  }\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px 8px;\n  transition: color 0.2s;\n\n  &:hover {\n    color: #374151;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapsed": `styles_collapsed__1EIN6`,
	"chat": `styles_chat__cL6TF`,
	"floating": `styles_floating__+8170`,
	"header": `styles_header__HCJug`,
	"logoButton": `styles_logoButton__-E4xR`,
	"title": `styles_title__ztkju`,
	"headerActions": `styles_headerActions__Mimzc`,
	"clearButton": `styles_clearButton__q9JFs`,
	"dragHandle": `styles_dragHandle__f8+iR`,
	"messages": `styles_messages__Xa+jN`,
	"welcome": `styles_welcome__T1hid`,
	"hint": `styles_hint__vuddK`,
	"message": `styles_message__Guv4x`,
	"user": `styles_user__uxMF9`,
	"assistant": `styles_assistant__sWyMk`,
	"loading": `styles_loading__iH22D`,
	"dot": `styles_dot__DP3sJ`,
	"bounce": `styles_bounce__9Qp3-`,
	"inputArea": `styles_inputArea__L0q-C`,
	"sendButton": `styles_sendButton__YoA4O`,
	"mobileOverlay": `styles_mobileOverlay__V07cz`,
	"mobileChatContainer": `styles_mobileChatContainer__fJtnN`,
	"mobileChatContent": `styles_mobileChatContent__EVyl2`,
	"closeButton": `styles_closeButton__5t-dv`
};
export default ___CSS_LOADER_EXPORT___;
